import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import darkTheme from './theme';
import AppContent from './AppContent'; // 👈 импортируем готовый компонент
import ForgotPasswordPage from './pages/Auth/ForgotPasswordPage';
import ResetPasswordPage from './pages/Auth/ResetPasswordPage';
import VerifyEmailPage from './pages/Auth/VerifyEmailPage';

function App() {
  const buildVersion = process.env.REACT_APP_BUILD_VERSION;

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <Router>
        <Routes>
          {/* Публичные страницы писем: без проверки сессии и без нижней навигации, работают и при входе, и без него */}
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/verify-email" element={<VerifyEmailPage />} />
          <Route path="*" element={<AppContent buildVersion={buildVersion} />} />  {/* 👈 внутри Router — здесь useNavigate работает корректно */}
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
